/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Unit_MInputs */

const en_us2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const pt_br2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const es_419_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const pt_pt2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const fr_fr2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const de_de2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

const it_it2_exercise_sheet_unit_m = /** @type {(inputs: Exercise_Sheet_Unit_MInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m`)
};

/**
* | output |
* | --- |
* | "m" |
*
* @param {Exercise_Sheet_Unit_MInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_unit_m = /** @type {((inputs?: Exercise_Sheet_Unit_MInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Unit_MInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_unit_m(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_unit_m(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_unit_m(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_unit_m(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_unit_m(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_unit_m(inputs)
	return en_us2_exercise_sheet_unit_m(inputs)
});
export { exercise_sheet_unit_m as "exercise-sheet.unit_m" }